import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { throwError } from 'rxjs';
// import { PRODUCT_CONFIGURATOR_QTY_LIMIT } from 'config';
import { ANALYTICS_CONSTANTS } from 'config';
import { FormControl } from '@angular/forms';
import { HttpClientService, AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers';
declare var ENV_PORTAL;
@Injectable()
export class ProductConfiguratorService {
  constructor(private http: HttpClient, private httpClientService: HttpClientService,
    private adobeAnalyticsService: AdobeAnalyticsService, private utilityService: UtilityService) { }
  getProductDetails(getProductDetailsservice) {
    console.log(getProductDetailsservice);
    return this.httpClientService.get(getProductDetailsservice)
      .pipe(
       map((test: HttpResponse<any>) => test.body)
      ,catchError( this.handleError ));
    // console.log(test);
  }

  getPricingDetails(getPricingDetailsservice) {
    return this.httpClientService.get(getPricingDetailsservice)
      .pipe(
       map((test: HttpResponse<any>) => test.body)
      ,catchError( this.handleError ));
  }


  getPricingInfo(getPricingDetailsservice, requestPriceInfoObj) {

    return this.httpClientService.authorizedPost(getPricingDetailsservice, requestPriceInfoObj)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  checkQty(val, limit) {
    return (group: FormGroup) => {
      const qty = group.controls[val];
      if (qty.value.length === 0) {
        return qty.setErrors({ 'required': true });
      } else {
        const qtyVal = Number(group.controls[val].value);
        if ((qtyVal !== null) && (qtyVal !== undefined) && (Number(qtyVal) === 0)) {
          return qty.setErrors({ 'pattern': true });
        } else if (qtyVal > limit) {
          return qty.setErrors({ 'limitErr': true });
        }
      }
    };
  }

  // Page Load
  createPageLoadProperties(skus, url: string, title: string) {
    const dataLayer = {};
    const removeProductId = url.substring(0, url.lastIndexOf('/'));
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = ANALYTICS_CONSTANTS.ENVIRONMENT_URL + removeProductId;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_PRODUCT_CONFIGURATOR;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_SHOP;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    let sku;
    for (const lineItem of skus) {
      sku = (sku === undefined) ? lineItem.socCode : sku + '|' + lineItem.socCode;
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = sku;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Sales';
    if (ENV_PORTAL === 'fnabc') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRSTNET_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE] = ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE;
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  createAdobeEventProperties(product: any, status: string, event: string, type: string, errorCode?: string, errorText?: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = ANALYTICS_CONSTANTS.EVENT_CODE_BC_CART_ADD_SUBMIT;
    dataLayer[ANALYTICS_CONSTANTS.EVENT_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_SHOP;
    if (status === 'SUCCESS') {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS] = [];
      const items = {};
      items['itemSku'] = product.sku.id;
      items['addToCartMethod'] = 'BUY';
      items['itemQty'] = product.quantity;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS].push(items);
      dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_SUCCESS_TYPE;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
    } else {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_FAILURE_TYPE_FAILURE_SYSTEM;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = errorCode;
      // this.dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_MESSAGE] = errorText;
    }
    this.adobeAnalyticsService.tag('event', dataLayer, ANALYTICS_CONSTANTS.EVENT_CODE_BC_CART_ADD_SUBMIT, event);
  }

  handleError = (error) => {
    return throwError(error);
  }
}

